import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Select from "common/components/Form/Select";
import {formatPriceWithDecimal} from "common/helpers/priceFormat";
import { t } from "translates";
import Icon from "common/components/Icon";
import classNames from "classnames";
import isMobile from "common/helpers/isMobile";
import ContentMessage from "../../../common/components/contentMessage";
import LazyLoadImageComponent from "common/components/LazyLoadImage";
import { getProductToAnalytics } from "./Cart";
import ConfirmBox from "../../../common/components/ConfirmBox";
const pg_type = window.drupalSettings && window.drupalSettings.pg_type || '';

export default class CartItem extends Component {
  static propTypes = {
    currency: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    currencyCode: PropTypes.string.isRequired,
    separator: PropTypes.string.isRequired,
    item: PropTypes.object.isRequired,
    actions: PropTypes.shape({
      cart: PropTypes.shape({
        onSelectPerson: PropTypes.func,
        onDeleteSession: PropTypes.func,
        onUpdateGift: PropTypes.func,
        fetch: PropTypes.func,
      }),
      reservation: PropTypes.shape({
        fetch: PropTypes.func,
      }).isRequired,
    }).isRequired,
    cart: PropTypes.shape({
      dialog: PropTypes.object,
      currency_decimal_separator: PropTypes.string.isRequired,
      currency_position: PropTypes.string.isRequired,
      currency_separator: PropTypes.string.isRequired,
      currency_symbol: PropTypes.string.isRequired,
    }).isRequired,
    onToggleCartState: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
    onDeleteHandler: PropTypes.func.isRequired,
    onSelectPersonHandler: PropTypes.func.isRequired,
    itemListName: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);

    this.item = this.props.item;
    this.includeTax = this.props.includeTax;
    const { item, includeTax } = props;
    const includedTax = includeTax ? item.persons * item.tax : 0;
    this.state = {
      price: item.price * item.persons + includedTax,
      isOpen: false,
      confirmText: "Are you sure you want to delete this item?",
      openedCourses: {},
      giftPrice: 0,
      editable: true,
      persons: item.persons,
      giftTitle: ""
    };
    this.cart = this.props.cart;

    this.onSelectPerson = this.onSelectPerson.bind(this);
    this.onChangeNowClick = this.onChangeNowClick.bind(this);
    this.onDeleteSession = this.onDeleteSession.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onOpenConfirm = this.onOpenConfirm.bind(this);
    this.onEditHandler = this.onEditHandler.bind(this);
    this.renderSessionItem = this.renderSessionItem.bind(this);
    this.renderEditButton = this.renderEditButton.bind(this);
    this.toggleCourse = this.toggleCourse.bind(this);
    this.onGiftChange = this.onGiftChange.bind(this);
  }

  componentDidMount() {
    const {
      item: {
        price,
        editable,
        title,
      },
    } = this.props;
    if (editable !== undefined) {
      this.setState({
        editable,
      });
    }
    this.setState({
      giftPrice: price,
      giftTitle: title,
    });
  }

  onGiftChange(e) {
    const {
      actions,
      item: {
        type,
        id,
      },
      giftModal,
    } = this.props;
    const { gifts } = giftModal;
    const selectedGift = gifts.find((el) => el.id === e.target.value);
    actions.cart.onUpdateGift(e.target.value, id, type);
    let products = [];
    const item_list_name = this.props.itemListName;
    let productObj = getProductToAnalytics({
      ...selectedGift,
      data: {
        codeId: selectedGift.id,
      }
    });

    products.push(productObj);

    window.dataLayer &&
    window.dataLayer.push({
      event: "change_now",
      ecommerce: {
        currency: this.props.currencyCode,
        items: products,
      }
    });
    this.setState({
      giftPrice: Number(selectedGift.price),
      giftTitle: selectedGift.title,
      price: Number(selectedGift.price) + Number(selectedGift.tax),
    });
  }

  onSelectPerson(event) {
    const includedTax = this.includeTax
      ? event.target.value * this.item.tax
      : 0;
    this.props.actions.cart.onSelectPerson(
      event.target.value,
      this.item.id,
      this.item.type
    );
    this.setState({
      price: this.item.price * event.target.value + includedTax,
      persons: event.target.value,
    });
    this.props.onSelectPersonHandler();

    let products = [];
    const item_list_name = this.props.itemListName;
    let productObj = {
      ...getProductToAnalytics(this.item),
      course_participants: event.target.value,
    };

    products.push(productObj);

    window.dataLayer &&
    window.dataLayer.push({
      event: "change_now",
      ecommerce: {
        currency: this.props.currencyCode,
        items: products,
      }
    });
  }

  get persons() {
    return new Array(this.item.available_places).fill(1).map((_, index) => (
      <option key={Math.random()} value={index + 1}>
        {index + 1} {t("pers.", DT_CART)}
      </option>
    ));
  }

  onDeleteSession(e, title) {
    e.preventDefault();
    const { item } = this;
    let products = [];
    let productObj = getProductToAnalytics(item);

    products.push(productObj);

    window.dataLayer &&
    window.dataLayer.push({
      event: "remove_from_cart",
      ecommerce: {
        currency: this.props.currencyCode,
        items: products,
      }
    });

    this.props.onDeleteHandler(this.item.id, item.type === 'sessions' ? item.product_title : item.title);
    this.props.actions.cart.onDeleteSession(this.item.id);
  }

  onChangeNowClick({ product_id, date }) {
    return (e) => {
      this.props.onToggleCartState(e);
      this.props.actions.reservation.fetch({
        product_id,
        date,
      });
    };
  }

  handleClose() {
    this.setState({
      isOpen: false,
    })
  }

  handleConfirm(e, title) {
    this.onDeleteSession(e, title);
  }

  handleCancel() {
    this.setState({
      isOpen: false,
    })
  }

  onOpenConfirm(e) {
    e.preventDefault();
    const type = this.props.item.type;
    let title = '';
    switch (type) {
      case 'gc_products':
        title = this.props.item.title;
        break;
      case 'cursus':
        title = `${this.props.item.title} (${this.props.item.count})`;
        break;
      case 'sessions':
        title = this.props.item.product_title;
        break;
    }
    this.setState({
      confirmText: `${t("You are about to remove this item:", DT_CART)} ${title}`,
      isOpen: true,
    })
  }

  onEditHandler(e, id, session, title, productTitle) {
    e.preventDefault();
    const {
      onEdit,
      item: {
        product_id,
        id: sessionId,
      },
      item,
    } = this.props;
    onEdit(
      id ? id : product_id,
      sessionId,
      item,
      session,
      title,
      productTitle,
    );


  }

  toggleCourse(index)  {
    if (isMobile) {
      this.setState({
        openedCourses: {
          ...this.state.openedCourses,
          [index]: this.state.openedCourses[index] ? !this.state.openedCourses[index] : true,
        }
      })
    }
  }

  renderSessionItem({session, isCursus, count, sessions, productTitle, index, hasExpired}) {
    const {
      is_other_sessions_are_available
    } = session;
    if (!session) return null;
    const session_debug = session.session_debug;
    const title = session.product_title && isCursus
      ? `${t("Course", DT_CART)} ${count}/${sessions.length}: ${session.product_title}`
      : undefined;
    return (
      <div className={classNames("session-item__info",
        {
          opened: this.state.openedCourses[index],
        }
      )}>
        {title && (
          <div className="session-item__title" onClick={() => this.toggleCourse(index)}>
            {title}
          </div>
        )}
        {hasExpired ? (
          <Fragment>
            <div className="cart-new-item__error-message">
              <ContentMessage message={t("course_is_not_available", DT_CART)} className="content-message--small" />
              {session_debug && Object.keys(session_debug).length > 0 && (
                <ContentMessage message={(<Fragment>
                  <p>{t('Requested places', DT_CART)}: {this.state.persons} - {t('Avaiblable stock', DT_CART)}: { session.available_places }</p>
                  <p>{t('Avaiblable online', DT_CART)}: {t(session_debug.available_online ? 'Yes' : 'No', DT_CART)} - {t('Block registrations', DT_CART)}: {t(session_debug.block_registrations ? 'Yes' : 'No', DT_CART)}</p>
                  <p>{t('Qualified', DT_CART)}: {t(session_debug.qualified ? 'Yes' : 'No', DT_CART)} - {t('Archived', DT_CART)}: {t(session_debug.archived ? 'Yes' : 'No', DT_CART)} - {t('Deleted', DT_CART)}: {t(session_debug.deleted ? 'Yes' : 'No', DT_CART)}</p>
                </Fragment>)} className="content-message--small" />
              )}
            </div>
          </Fragment>
        ) : (
          <div className="session-item__information">
            <div className="session-item__information__item cart-new-item__date">
              {session.display_date}
            </div>
            <div className="session-item__information__item cart-new-item__time">
              {session.display_time}
            </div>
            {session.language && (
              <div className="session-item__information__item cart-new-item__language">
                {session.language}
              </div>
            )}
          </div>
        )}

        {this.state.editable && is_other_sessions_are_available && this.renderEditButton(session, isCursus, title, productTitle)}
      </div>
    )
  }

  renderEditButton(session, isCursus, title, productTitle) {
    return <div className={classNames('session-item__edit icon-link', {
      'session-item__edit--cursus': isCursus,
    })}>
      <a href="#" onClick={(e) => this.onEditHandler(
        e,
        session.product_id,
        isCursus ? session : undefined,
        title,
        productTitle,
      )}>
        <span className="cart-new-item__icon icon-link__icon">
          <Icon name="edit" />
        </span>
        {t("Modify", DT_CART)}
      </a>
    </div>
  }

  render() {
    let {
      item: {
        id,
        product_id,
        date,
        available_places,
        is_other_sessions_are_available,
        sessions_has_expired,
        type,
        persons,
        data,
        hasExpiredCursus,
        hasExpiredSeriesSessions,
        cursusId,
        image,
        category_type,
        session_debug,
        ...item
      },
      staffUser,
      separator,
      giftModal,
    } = this.props;

    const {
      isOpen,
      confirmText,
      giftPrice,
      giftTitle,
    } = this.state;

    const { gifts } = giftModal;

    const isCursus = type === 'cursus';
    const isSession = type === 'sessions';
    const isGift = type === 'gc_products';

    const currentGift = giftPrice && gifts.find((gift) => Number(gift.price) === Number(giftPrice));

    let title = '';
    switch (type) {
      case 'cursus':
        title = item.title;
        break;
      case 'sessions':
        title = item.product_title;
        break;
      default:
        title = '';
    }
    return (
      <div>
        <Fragment>
          <ConfirmBox
            options={{
              text: confirmText,
              confirm: t("Confirm removal", DT_CART),
              cancel: t("Cancel removal", DT_CART),
            }}
            isOpen={isOpen}
            onClose={this.handleClose}
            onConfirm={(e) => this.handleConfirm(e, title)}
            onCancel={this.handleCancel}
          />
        </Fragment>
        <div
          className={classNames("cart-new-item", {
            "cart-new-item--gift": isGift,
            "cart-new-item--cursus": isCursus,
          })}
          style={{
            borderTopColor: isGift ? "#9FAFBA" : item.color,
          }}
        >
          <div className="cart-new-item__image">
            <div className="cart-new-item__img">
              {image && (
                <LazyLoadImageComponent src={image.uri} alt={image.alt} title={image.title} />
              )}
            </div>
          </div>
          <div className="cart-new-item__information">
            <div className="cart-new-item__row">
              <div className="cart-new-item__left">
                <div className="info-block">
                  <span
                    className="cart-new-item__label"
                    style={{
                      backgroundColor:
                        isGift ? "#9FAFBA" : item.color,
                    }}
                  >
                    {category_type !== undefined
                      ? category_type
                      : "package"}
                  </span>
                  <h2 className="cart-new-item__title">
                    {isGift ? giftTitle : title} {item.count && !isGift && (<Fragment>({item.count})</Fragment>)}
                  </h2>
                  {isGift && (
                    <Fragment>
                      <div className="gift-select">
                        <div className="cart-new-item__select">
                          {currentGift && (
                            <Select
                              type="select"
                              name="gift"
                              defaultValue={currentGift.id}
                              value={currentGift.id}
                              onChange={this.onGiftChange}
                              className="gift-modal-dialog__select-amount"
                            >
                              {gifts.map(({ id, price_amount: price, title }) => (
                                <option
                                  key={id}
                                  value={id}
                                >
                                  {title} - {price}
                                </option>
                              ))}
                            </Select>
                          )}
                        </div>
                      </div>
                    </Fragment>
                  )}
                </div>
                {!sessions_has_expired &&
                  !isCursus && (
                    this.renderSessionItem({
                      session: this.props.item,
                      hasExpired: available_places === 0 || available_places < persons,
                    })
                  )}
                {/*session items*/}

                {isCursus &&
                  available_places > 0 &&
                  available_places >= persons &&
                  !hasExpiredCursus && (
                    <Fragment>
                      <div
                        className={classNames("session-items")}
                      >
                        {item.sessions.map(({ ...session }, index) => (
                          <Fragment key={session.id + index}>
                            {this.renderSessionItem(
                              {
                                session,
                                isCursus,
                                count: index + 1,
                                sessions: item.sessions,
                                productTitle: title,
                                index: session.id + index
                              }
                            )}
                          </Fragment>
                        ))}
                      </div>
                    </Fragment>
                  )}
                {/* /session items*/}
                {isSession && (
                  <Fragment>
                    {(sessions_has_expired) && (
                      <Fragment>
                        <div className="cart-new-item__error-message">
                          <ContentMessage message={t("course_is_not_available", DT_CART)} className="content-message--small" />
                          {session_debug && Object.keys(session_debug).length > 0 && (
                            <ContentMessage message={(<Fragment>
                              <p>{t('Requested places', DT_CART)}: {persons} - {t('Avaiblable stock', DT_CART)}: { available_places }</p>
                              <p>{t('Avaiblable online', DT_CART)}: {t(session_debug.available_online ? 'Yes' : 'No', DT_CART)} - {t('Block registrations', DT_CART)}: {t(session_debug.block_registrations ? 'Yes' : 'No', DT_CART)}</p>
                              <p>{t('Qualified', DT_CART)}: {t(session_debug.qualified ? 'Yes' : 'No', DT_CART)} - {t('Archived', DT_CART)}: {t(session_debug.archived ? 'Yes' : 'No', DT_CART)} - {t('Deleted', DT_CART)}: {t(session_debug.deleted ? 'Yes' : 'No', DT_CART)}</p>
                            </Fragment>)} className="content-message--small" />
                          )}
                        </div>
                      </Fragment>
                    )}
                  </Fragment>
                )}
                {isCursus && (
                  <Fragment>
                    {hasExpiredCursus || hasExpiredSeriesSessions && (
                      <Fragment>
                        <div className="cart-new-item__error-message">
                          <ContentMessage message={t("course_is_not_available", DT_CART)} className="content-message--small"/>
                          {session_debug && Object.keys(session_debug).length > 0 && (
                            <ContentMessage message={(<Fragment>
                              <p>{t('Requested places', DT_CART)}: {persons} - {t('Avaiblable stock', DT_CART)}: {available_places}</p>
                              <p>{t('Avaiblable online', DT_CART)}: {t(session_debug.available_online ? 'Yes' : 'No', DT_CART)} - {t('Block registrations', DT_CART)}: {t(session_debug.block_registrations ? 'Yes' : 'No', DT_CART)}</p>
                              <p>{t('Qualified', DT_CART)}: {t(session_debug.qualified ? 'Yes' : 'No', DT_CART)} - {t('Archived', DT_CART)}: {t(session_debug.archived ? 'Yes' : 'No', DT_CART)} - {t('Deleted', DT_CART)}: {t(session_debug.deleted ? 'Yes' : 'No', DT_CART)}</p>
                            </Fragment>)} className="content-message--small" />
                          )}
                        </div>
                      </Fragment>
                    )}
                  </Fragment>
                )}
              </div>
              <div className="cart-new-item__right">
                <div className="cart-new-item__info">
                  <div className="cart-new-item-inner__row">
                    <div className="cart-col col--select">
                      {available_places > 0 &&
                      available_places >= persons &&
                      !sessions_has_expired ? (
                        <Fragment>
                          <div className="cart-new-item__select">
                            <Select
                              id={`persons-${id}`}
                              type="select"
                              name={`persons-${id}`}
                              value={this.state.persons}
                              onChange={this.onSelectPerson}
                              disabled={staffUser}
                            >
                              {this.persons}
                            </Select>
                          </div>

                          <div className="session-item__actions">
                            {type !== "cursus" && (
                              <div className="session-item__edit icon-link">
                                <a href="#" onClick={this.onEditHandler}>
                                  <span className="cart-new-item__icon icon-link__icon">
                                    <Icon name="edit" />
                                  </span>
                                  {t("Modify", DT_CART)}
                                </a>
                              </div>
                            )}

                            <div className="session-item__remove icon-link">
                              <a href="#" onClick={this.onOpenConfirm}>
                                  <span className="cart-new-item__icon icon-link__icon">
                                    <Icon name="trash-new" />
                                  </span>
                                {t("Remove", DT_CART)}
                              </a>
                            </div>
                          </div>
                        </Fragment>
                      ) : <Fragment>
                        <div className="cart-new-item__select">
                        </div>

                        <div className="session-item__actions">
                          <div className="session-item__remove icon-link">
                            <a href="#" onClick={this.onOpenConfirm}>
                                  <span className="cart-new-item__icon icon-link__icon">
                                    <Icon name="trash-new" />
                                  </span>
                              {t("Remove", DT_CART)}
                            </a>
                          </div>
                        </div>
                      </Fragment>}
                    </div>
                    <div className="cart-col col--price">
                      {available_places > 0 &&
                        available_places >= persons &&
                        !sessions_has_expired && (
                          <span className="cart-new-item__price">
                          {formatPriceWithDecimal(Number(this.state.price), this.cart.currency_symbol, this.cart.currency_separator, this.cart.currency_decimal_separator, this.cart.currency_position)}
                        </span>
                        )}
                      {isGift && (
                        <span className="cart-new-item__price">
                          {formatPriceWithDecimal(Number(this.state.price), this.cart.currency_symbol, this.cart.currency_separator, this.cart.currency_decimal_separator, this.cart.currency_position)}
                        </span>
                      )}
                    </div>
                    <div className="cart-col col--delete">
                      <div className="cart-new-item__remove mobile-hidden tablet-hidden">
                        <a href="#" onClick={this.onOpenConfirm}>
                        <span className="cart-new-item__icon">
                          <Icon name="trash-new" />
                        </span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
